module.exports = __webpack_public_path__ + "static/media/logo.c37b8989.svg";